module.exports = __webpack_public_path__ + "img/24.36b7ea63.png";